// extracted by mini-css-extract-plugin
module.exports = {"edit-details-form":"EditDetailsForm_edit-details-form__6nLgI","footer":"EditDetailsForm_footer__3TkWD","select":"EditDetailsForm_select__1nHQH"};